import React from 'react';
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DayOfWeek from './enums/days-of-week-types';

interface RecurringDaysProps {
  selectedDays: DayOfWeek[];
  onChange: (selectedDays: DayOfWeek[]) => void;
}

const RecurringDays: React.FC<RecurringDaysProps> = ({ selectedDays, onChange }) => {
  const { t } = useTranslation();

  const toggleDay = (day: DayOfWeek): void => {
    const updatedDays = selectedDays.includes(day)
      ? selectedDays.filter((d) => d !== day)
      : [...selectedDays, day];
    onChange(updatedDays);
  };

  return (
    <FormGroup>
      {Object.values(DayOfWeek)
        .filter((day) => !Number.isNaN(Number(day)))
        .map((day) => (
          <FormControlLabel
            key={day}
            control={
              <Checkbox
                checked={selectedDays.includes(day as DayOfWeek)}
                onChange={(): void => toggleDay(day as DayOfWeek)}
              />
            }
            label={t(`daysOfWeek.${DayOfWeek[day as DayOfWeek]}`)}
            style={{ color: 'black' }}
          />
        ))}
    </FormGroup>
  );
};

export default RecurringDays;
